import EHIModal from '../../../../react/components/ehi-modal/ehi-modal.js';
import Vimeo from '../javascripts/vimeo-player-2.25.0.js';

const ReactDOM = window.ReactDOM ?? null;

class App extends EHIModal {
    moduleElement;
    player;
    vimeoData;
    data;

    activeTrigger;
    triggerSelector;

    constructor(props) {
        super(props);

        this.moduleElement = props.moduleElement;
        this.data = props.data;
        this.activeTrigger = props.activeTrigger ?? null;
        this.triggerSelector = props.triggerSelector ?? `[data-lum-member-vimeo-modal="${this.getSetting('modalId', '')}"]` ?? null;

        this.config.id = 'ehi-modal';
        this.config.modalClass = `vimeo-modal modal-${this.data.slug} ${this.getSetting('modalClasses')}`;
        this.config.destroyOnCancel = false;
    }

    afterComponentDidMount() {
        document.body.addEventListener('click', this.onBodyClick);

        if (this.props.openNow) {
            this.setState({ active: true });
        }
    }

    componentDidUpdate(prevProps, prevState) {
    }

    afterComponentWillUnmount() {
        document.body.removeEventListener('click', this.onBodyClick);
    }

    async mountModalBodyContent() {
        if (!this.bodyRef.current) {
            return;
        }

        const content = await this.getModalBodyContent();

        if (typeof content === 'string') {
            this.bodyRef.current.innerHTML = content;
        } else {
            this.bodyRef.current.appendChild(content);
        }
    }

    isEditor() {
        return (window.FLBuilder && document.body.classList.contains('fl-builder-edit') && new URLSearchParams(window.location.search).has('fl_builder'));
    }

    hasAnalyticsConsent() {
        return (typeof Cookiebot !== 'undefined') ? Cookiebot.consent?.statistics : true;
    }

    getId() {
        return this.data.node ?? '';
    }

    getSlug() {
        return this.data.slug ?? '';
    }

    getSetting(prop, fallback=null) {
        return this.data.settings[prop] ?? fallback;
    }

    getVideoUrl() {
        return `https://vimeo.com/${this.getSetting('videoId')}`;
    }

    getEndpoint() {
        const endpoint = new URL('https://vimeo.com/api/oembed.json');
        endpoint.searchParams.set('url', this.getVideoUrl());

        if (!this.hasAnalyticsConsent()) {
            endpoint.searchParams.set('dnt', '1');
        }

        return endpoint.toString();
    }

    async getModalBodyContent() {
        if (this.config.modalBodyContent) {
            return this.config.modalBodyContent;
        };

        this.vimeoData = await fetch (this.getEndpoint()).then((response) => {
            if (!response.ok) {
                console.error(`Error fetching Vimeo oEmbed data: ${response.status}`);
                return {};
            }
            return response.json();
        }).then((data) => {
            return data;
        });

        const vimeoEl = document.createElement('div');

        if (this.vimeoData?.html) {
            const ratio = Math.round((this.vimeoData.width / this.vimeoData.height) * 100);
            const ratioClass = (ratio == 178) ? 'ratio-16x9' : 'ratio-4x3';

            const iframe = new DOMParser().parseFromString(this.vimeoData.html, 'text/html').body.firstElementChild;
            iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation');

            const allow = iframe.getAttribute('allow') || '';
            iframe.setAttribute('allow', (allow) ? `${allow}; presentation` : 'presentation');

            vimeoEl.classList.add('vimeo-container', ratioClass);
            vimeoEl.appendChild(iframe);

            this.player = (iframe) ? new Vimeo(iframe) : null;

            window.vimeo = Vimeo;
            window.thisPlayer = this.player;
        } else {
            vimeoEl.classList.add('video-not-available');
            vimeoEl.insertAdjacentHTML('beforeend', this.getSetting('videoNotAvailableMessage'));
        }

        this.config.modalBodyContent = vimeoEl;
        return vimeoEl;
    }

    onAfterCancelButtonClick = (event) => {
		if (event instanceof Object === false) {
			return;
		}
        
        this.setState({ active: false });

        if (this.activeTrigger) {
            this.activeTrigger.focus();
        }

        if (this.player) {
            this.player.pause();
        }
	}

    onBodyClick = (event) => {
        const trigger = event.target.closest(this.triggerSelector);
        if (!trigger) {
            return;
        }

        event.preventDefault();

        this.activeTrigger = trigger;

        this.setState(prev => ({ active: !prev.active }));
    }
}

export default App;